import React from 'react';
import CardTitle from './CardTitle';
import styles from './WorldsBestTitle.module.scss';

export const WorldsBestTitle: React.FC = () => (
  <CardTitle
    text={
      <div className={styles.titleWrapper}>
        <span>WORLD&apos;S BEST SHAPING.</span>
        <span>BUILT INTO SHAPEWEAR,</span>
        <span>INTIMATES AND OUTERWEAR.</span>
      </div>
    }
  />
);

export default WorldsBestTitle;
